import React ,{useState} from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './contact.css'
import { AiFillGithub, AiOutlineTwitter } from 'react-icons/ai';
import { FaLinkedinIn } from 'react-icons/fa';
import emailjs from 'emailjs-com';
import { init } from 'emailjs-com';
init('user_ezIfl35D12EELOcmuapOt');

export default function Contact() {
  const [message, setMessage] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        'Portfolio_emails_service',
        'PortfolioMailer_brijesh',
        e.target,
        'user_ezIfl35D12EELOcmuapOt'
      )
      .then((res) => {
        console.log(res);
        setMessage(true);
      })
      .catch((err) => {
        console.log(err);
        setMessage(false);
      });
  };
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col className="right">
      
          
            <div className="home-about-social">
            <h1>CONTACT ME</h1>
            <p>
              Drop a message <span className="purple">here </span>
            </p>
            </div>
            <form onSubmit={handleSubmit}>
              <input
                type="email"
                name="user_email"
                placeholder="Email"
                required
              />
              <input type="text" name="from_name" placeholder="Name" />
              <textarea
                name="message"
                placeholder="Message"
                required
              ></textarea>
              <br/>
              <button type="submit">Send</button>
              <br/>
              {message && <span>Thanks, Message Sent!! </span>}
            </form>
          </Col>
          <Col md={12} className="home-about-social">
          <p>
              Feel Free to <span className="purple">Connect </span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Burfal18"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/BrijeshBurfal"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/Brijesh-Burfal/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

